// import CONSTANTS from "../constants";

export function pushToGTMTracker(trackIdentifier, pageTitle, dealer = {}) {
	switch (trackIdentifier) {
		case "vehicle-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/car-details",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "1",
				'mainStepName': "car details",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;
		case "dealer-locator":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/search",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page"
			});

			break;
		case "dealer-list":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/list",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page"
			});

			break;
		case "operation-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/services",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "2",
				'mainStepName': "services",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;
		case "quote-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/quoting",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "3",
				'mainStepName': "quoting",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;
		case "appointment-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/appointment",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "4",
				'mainStepName': "appointment",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;
		case "personal-informations-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/personal-informations",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "5",
				'mainStepName': "personal informations",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;
		case "summary-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/summary",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "form page",
				'mainStepIndicator': "6",
				'mainStepName': "summary",
				'formsName': "quote request",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;

		case "confirmation-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/intervention/confirmation",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': (window.siteConfig['currentCountry']).toLowerCase(),
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "lead page",
				'formsLeadType': "cold lead",
				'formsPostalCode': window.siteConfig['formsPostlCode'],
				'formsName': "quote request",
				'mainStepIndicator': "7",
				'mainStepName': "confirmation",
				"edealerName": dealer.name,
				"edealerSiteGeo": dealer.geoID,
				"edealerID": dealer.iD,
				"edealerCity": dealer.city,
				"edealerIDLocal": dealer.IDLocal,//missing
				"edealerAddress": dealer.adress,
				"edealerPostalCode": dealer.zip,
				"edealerRegion": dealer.Region,//missing
				"edealerPDV": dealer.PDV,//missing
				"edealerCountry": dealer.culture!==undefined && dealer.culture.split('-')[1]
			});

			break;

		default:
			console.error('this tracker "' + trackIdentifier + '" is not identified , please contact the administrator!');
			break;
	}

}
export function pushEventToGTM(content) {
	window.dataLayer.push({
		'pageName': content.pageName,
		'event': 'uaevent',
		'eventCategory': content.eventCategory,
		'eventAction': content.eventAction,
		'eventLabel': content.eventLabel
	});
}
